export default __webpack_public_path__ + "static/media/passive-changes.31e3c8c3.png";